/* ── Redesign layer (DRAFT theme): load redesign.css after the original
   stylesheets (config.js runs in <head> right after them) + smooth cart. ── */
(function () {
  try {
    var me = document.currentScript && document.currentScript.src;
    if (me) {
      var href = me.replace(/config\.js(\?.*)?$/, 'redesign.css') + '?v=1791258877656';
      document.write('<link rel="stylesheet" href="' + href + '">');
    }
  } catch (e) {}

  /* ── Prices: Shopify is the single source (window.FLUX_PRICES is printed inline by the
     flux-prices snippet). fluxP(name, variant, fallback) -> price; fluxReprice(data) rewrites the
     page's own product lists in place before they render. ── */
  var NAME_ALIAS = { 'bac water': 'bacteriostatic water', 'aa water': 'acetic acid water',
    'glp-1': 'semaglutide', 'glp-2': 'tirzepatide', 'glp-3': '(glp-3) reta', 'retatrutide': '(glp-3) reta',
    'glp-1 pen': 'semaglutide pen', 'glp-2 pen': 'tirzepatide pen', 'glp-3 pen': '(glp-3) reta pen', 'retatrutide pen': '(glp-3) reta pen' };
  function nz(s) { return String(s == null ? '' : s).toLowerCase().replace(/[\s,.\-·]/g, ''); }
  function shopName(name) { var n = String(name || '').toLowerCase().trim(); return NAME_ALIAS[n] || n; }
  function shopVariants(name) {
    var P = window.FLUX_PRICES; if (!P) return null;
    var n = shopName(name);
    for (var k in P) if (k.toLowerCase() === n) return P[k];
    return null;
  }
  /* match a site variant label to a Shopify variant: '10mg', '5000IU', '2×10mg' -> '2-Pack (2×10mg)', '10 pcs' -> 'Pack of 10' */
  function findVariant(vs, label) {
    if (!vs || !vs.length) return null;
    var w = String(label == null ? '' : label).trim();
    var pack = w.match(/^(\d+)\s*[×x]\s*(.+)$/), pcs = w.match(/^(\d+)\s*(pcs|pieces|pack)\b/i) || w.match(/^pack of (\d+)$/i);
    if (pack) {
      var key = nz(pack[1] + '×' + pack[2]);
      return vs.find(function (v) { return nz(v.t).indexOf('(' + key + ')') !== -1 || nz(v.t) === key; }) || null;
    }
    if (pcs) return vs.find(function (v) { return nz(v.t) === 'packof' + pcs[1]; }) || null;
    if (vs.length === 1) return vs[0];
    if (!w) return null;
    return vs.find(function (v) { return nz(v.t) === nz(w); })
        || vs.find(function (v) { return nz(v.t).indexOf(nz(w)) === 0 && !/pack/i.test(v.t); }) || null;
  }
  window.fluxVariant = function (name, label) { return findVariant(shopVariants(name), label); };
  window.fluxP = function (name, label, fallback) {
    var v = findVariant(shopVariants(name), label);
    return v ? Math.round(v.p) : (fallback === undefined ? null : fallback);
  };
  function fromPrice(name) {
    var vs = shopVariants(name); if (!vs || !vs.length) return null;
    var singles = vs.filter(function (v) { return !/pack/i.test(v.t); });
    var list = singles.length ? singles : vs;
    return Math.round(Math.min.apply(null, list.map(function (v) { return v.p; })));
  }
  window.fluxReprice = function (root) {
    if (!window.FLUX_PRICES) return root;
    (function walk(o, name, depth) {
      if (!o || typeof o !== 'object' || depth > 5 || o.nodeType) return;
      if (Array.isArray(o)) { o.forEach(function (x) { walk(x, name, depth + 1); }); return; }
      var nm = (typeof o.name === 'string' && o.name) || (typeof o.n === 'string' && o.n) || name;
      ['sizes', 'variants', 'doses', 'options'].forEach(function (key) {
        if (!Array.isArray(o[key]) || !nm) return;
        o[key].forEach(function (e) {
          if (!e || typeof e.price !== 'number') return;
          var v = findVariant(shopVariants(nm), e.size != null ? e.size : e.label);
          if (!v) return;
          e.price = Math.round(v.p);
          if ('origPrice' in e) e.origPrice = v.c > v.p ? Math.round(v.c) : (e.origPrice > e.price ? e.origPrice : undefined);
        });
      });
      if (typeof o.from === 'number' && nm) { var f = fromPrice(nm); if (f) o.from = f; }
      if (typeof o.price === 'number' && o.variant != null && nm) { var p = window.fluxP(nm, o.variant, null); if (p) o.price = p; }
      for (var k in o) if (o[k] && typeof o[k] === 'object' && k !== 'sizes' && k !== 'variants' && k !== 'doses' && k !== 'options') walk(o[k], nm, depth + 1);
    })(root, null, 0);
    return root;
  };
  /* carts saved before a price change are re-priced on load, so cart total = checkout total */
  try {
    var _c = JSON.parse(localStorage.getItem('fluxCart') || '[]'), _dirty = false;
    _c.forEach(function (it) {
      var p = window.fluxP(it.name, it.variant, null);
      if (p != null && p !== it.price) { it.price = p; _dirty = true; }
    });
    if (_dirty) localStorage.setItem('fluxCart', JSON.stringify(_c));
  } catch (e) {}

  /* Speed: the old full-screen particle animation (hidden by redesign.css) still redrew
     ~7,000 lines every frame on all pages. Let it run its first frame, then stop it. */
  try {
    var _raf = window.requestAnimationFrame;
    window.requestAnimationFrame = function (cb) {
      if (cb && cb.name === 'drawParticles') return 0;
      return _raf.call(window, cb);
    };
    var _gc = HTMLCanvasElement.prototype.getContext;
    var noop = function () {};
    var stub = { clearRect: noop, beginPath: noop, arc: noop, fill: noop, moveTo: noop, lineTo: noop, stroke: noop };
    HTMLCanvasElement.prototype.getContext = function (t) {
      if (this.id === 'particle-canvas') return stub;
      return _gc.apply(this, arguments);
    };
  } catch (e) {}

  /* Smooth cart drawer: scroll lock, staggered items on open, no re-animation
     flicker on qty changes, Esc to close, swipe-right to close on phones. */
  function initCart() {
    var drawer = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartOverlay');
    if (!drawer || drawer.__rd) return;
    drawer.__rd = true;
    var wasOpen = false, t;
    function sync() {
      var open = drawer.classList.contains('open');
      if (open === wasOpen) return;
      wasOpen = open;
      document.documentElement.classList.toggle('rd-cart-open', open);
      if (open) {
        drawer.classList.add('rd-opening');
        clearTimeout(t);
        t = setTimeout(function () { drawer.classList.remove('rd-opening'); }, 900);
      }
    }
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    function close() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
    /* swipe right to dismiss */
    var x0 = null, y0 = 0, dx = 0, horiz = null;
    drawer.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horiz = null;
    }, { passive: true });
    drawer.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (horiz === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horiz = Math.abs(mx) > Math.abs(my);
      if (!horiz) return;
      dx = Math.max(0, mx);
      drawer.style.transition = 'none';
      drawer.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });
    drawer.addEventListener('touchend', function () {
      if (x0 === null) return;
      drawer.style.transition = '';
      drawer.style.transform = '';
      if (horiz && dx > 90) close();
      x0 = null;
    });
  }
  /* Product page: sticky "Add to cart" bar on phones once the main button scrolls away */
  function initStickyBuy() {
    if (!document.getElementById('pdAdd') || document.querySelector('.rd-sticky-buy')) return;
    function add() { return document.getElementById('pdAdd'); }
    var bar = document.createElement('div');
    bar.className = 'rd-sticky-buy';
    bar.innerHTML = '<div class="rd-sb-info"><div class="rd-sb-name"></div><div class="rd-sb-price"></div></div><button type="button">Add to cart</button>';
    document.body.appendChild(bar);
    document.body.classList.add('rd-has-sticky');
    function fill() {
      var t = document.querySelector('.pd-title'), p = document.getElementById('pdPrice');
      bar.querySelector('.rd-sb-name').textContent = t ? t.textContent.trim() : '';
      bar.querySelector('.rd-sb-price').textContent = p ? p.textContent.trim() : '';
    }
    fill();
    bar.querySelector('button').addEventListener('click', function () { fill(); var b = add(); if (b) b.click(); });
    /* the page re-renders #pdAdd after load, so look it up fresh on every check */
    function check() {
      var b = add(); if (!b) return;
      var gone = b.getBoundingClientRect().bottom < 0;
      if (gone && !bar.classList.contains('show')) fill();
      bar.classList.toggle('show', gone);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
  /* Correct product photo for accessories in the cart (the "complete your kit"
     buttons add them without one, so the cart showed an emoji instead). */
  var CUT = 'https://flux-labs-6et.pages.dev/images/products/cutouts/';
  function accImg(name, variant) {
    var n = String(name || '').toLowerCase(), v = String(variant || '').toLowerCase();
    if (n === 'bac water' || n === 'bacteriostatic water') return CUT + (v.indexOf('3') === 0 ? 'bacwater-3ml.png' : 'bacwater-10ml.png');
    if (n === 'acetic acid water' || n === 'aa water') return CUT + 'aa-water-3ml.png';
    if (n === 'insulin syringes') return CUT + 'insulin-syringes.png';
    if (n === 'pen needles') return CUT + 'pen-needles.png';
    if (n === '(glp-3) reta') return 'https://cdn.shopify.com/s/files/1/0758/5428/2821/files/' +
      (/30\s*mg/.test(v) ? 'glp3-reta-30mg_618ab1f3-a8b0-4e6b-b626-da3ab25b603f.png' : 'glp3-reta_d6e59977-b8f0-42fa-8c40-4d07fb14cb26.png');
    return null;
  }
  try {   /* fix items already saved in the visitor's cart (runs before the page reads it) */
    var saved = JSON.parse(localStorage.getItem('fluxCart') || '[]'), dirty = false;
    saved.forEach(function (it) { var im = accImg(it.name, it.variant); if (im && it.img !== im) { it.img = im; dirty = true; } });
    if (dirty) localStorage.setItem('fluxCart', JSON.stringify(saved));
  } catch (e) {}
  function wrapCartAdd() {
    var orig = window.cartAdd;
    if (typeof orig !== 'function' || orig.__rd) return;
    var wrapped = function (p) {
      if (p && typeof p === 'object') { var im = accImg(p.name, p.variant); if (im) p.img = im; }
      return orig.apply(this, arguments);
    };
    wrapped.__rd = true;
    window.cartAdd = wrapped;
  }

  function boot() { wrapCartAdd(); initCart(); initStickyBuy(); setTimeout(function () { wrapCartAdd(); initStickyBuy(); }, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ════════════════════════════════════════════════
   Flux Labs — site configuration
   ▶ EDIT THE VALUES BELOW BEFORE GOING LIVE.
   This one file controls the WhatsApp number, email
   and business details used across the whole site.
════════════════════════════════════════════════ */
window.FLUX_CONFIG = {
  /* WhatsApp business number — digits only, with country code, NO "+" or spaces.
     Example for UAE: 9715XXXXXXXX  */
  whatsapp: '971544465004',

  /* Where order copies / enquiries should also be sent (optional, for your records) */
  email: 'fluxlabss@gmail.com',

  /* Shown in order messages and contact pages */
  businessName: 'Flux Labs',

  /* Ziina payments (manual, via WhatsApp): checkout places the order and opens
     WhatsApp; you reply with a Ziina payment link from the Ziina app.
     (A dormant "ziina" Edge Function exists for automatic links if you ever
     get a Ziina Business API key — secret ZIINA_API_KEY.)
     true = show "Pay with Ziina (card / Apple Pay)" at checkout. */
  cardPaymentsEnabled: true,

  /* ── Buy-now-pay-later (Tabby & Tamara) ──
     Split the order into 4 interest-free payments. Works the same manual way as
     Ziina: the customer places the order, WhatsApp opens, and you reply with a
     Tabby / Tamara payment link generated from your merchant dashboard.
     ▶ Flip to true ONLY once your Tabby / Tamara merchant account is APPROVED.
       (Leave false until then — an un-approved provider can't issue links.)
     When you later get API keys, paste the public key so we can show the live
     "split in 4" badge and, if you want, automate the payment link. */
  tabbyEnabled: false,
  tamaraEnabled: false,
  tabbyPublicKey: '',    /* pk_... from Tabby dashboard (optional, for the live badge) */
  tamaraPublicKey: '',   /* from Tamara dashboard (optional, for the live badge) */
  /* Minimum order (AED) BNPL providers accept — orders below this hide the split badge. */
  bnplMinAED: 100,

  /* Crypto payment (manual): shows your wallet addresses at checkout; customer pays
     and confirms via WhatsApp with the transaction hash.
     ▶ Replace the placeholders below with YOUR real wallet addresses to activate.
       Any address still containing "REPLACE" is hidden automatically. */
  cryptoEnabled: false,   /* temporarily OFF (2026-07-17) until NOWPayments account is verified — flip to true to bring crypto back */
  /* cryptoAuto: true = automatic confirmation via NOWPayments gateway (needs the
     NOWPAYMENTS_API_KEY secret in Supabase). false = manual (show wallet addresses). */
  cryptoAuto: true,
  crypto: {
    'BTC': 'bc1qamev600vvhtmvsr49e2jyeam7j65reya29kh3q',
    'ETH': '0x5C225e1144A8417B6781Dfd96897db4bC2378a80'
  },

  /* ── SHARED LIVE STOCK (Supabase) ──
     Paste these two values from your Supabase project
     (Project Settings → API). Leave blank to use the on-device stock instead.
     When both are filled, stock becomes automatic and shared across ALL visitors. */
  supabaseUrl: 'https://bwgvqblfjmxbpuyzjdki.supabase.co',
  supabaseAnonKey: 'sb_publishable_zj8jzOHPnKGzItIBRY5bQw_DZbrIJjS'
};

/* ── Shopify checkout bridge (2026-09-02) ──
   Replaces the legacy checkout modal (Ziina/WhatsApp flow) with real Shopify
   checkout. Maps the legacy localStorage cart (name+variant) onto Shopify
   variant IDs via /products.json, then jumps to a cart permalink, which lands
   on Shopify checkout (MyFatoorah / COD / bank transfer). */
(function () {
  var ALIAS = { 'bac water': 'bacteriostatic water', 'aa water': 'acetic acid water', 'glp-1': 'semaglutide', 'glp-2': 'tirzepatide', 'glp-3': '(glp-3) reta', 'retatrutide': '(glp-3) reta', 'glp-1 pen': 'semaglutide pen', 'glp-2 pen': 'tirzepatide pen', 'glp-3 pen': '(glp-3) reta pen' };
  var cache = null;
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function canon(s) { var n = norm(s); return ALIAS[n] || n; }
  function loose(s) { return norm(s).replace(/[^a-z0-9,]/g, ''); }
  function getCatalog() {
    if (cache) return Promise.resolve(cache);
    if (window.FLUX_PRICES) {   /* variant ids are printed into the page: no network call at checkout */
      cache = Object.keys(window.FLUX_PRICES).map(function (t) { return { title: t, variants: window.FLUX_PRICES[t].map(function (v) { return { id: v.id, title: v.t }; }) }; });
      return Promise.resolve(cache);
    }
    return fetch('/products.json?limit=250').then(function (r) { return r.json(); })
      .then(function (j) { cache = (j && j.products) || []; return cache; });
  }
  function matchVariant(prod, want) {
    var vs = prod.variants || [];
    if (!vs.length) return null;
    if (window.fluxVariant) {   /* shared matcher from the price engine (packs, pcs, IU) */
      var fv = window.fluxVariant(prod.title, want);
      if (fv) { var hit = vs.find(function (v) { return String(v.id) === String(fv.id); }); if (hit) return hit; }
    }
    var w = norm(want);
    if (!w || vs.length === 1) return vs[0];
    return vs.find(function (v) { return norm(v.title) === w; })
        || vs.find(function (v) { return norm(v.title).indexOf(w) === 0; })
        || vs.find(function (v) { return w.indexOf(norm(v.title)) === 0; })
        || vs.find(function (v) { return loose(v.title) === loose(w); })
        || null;
  }
  function shopifyCheckout() {
    var cart;
    try { cart = JSON.parse(localStorage.getItem('fluxCart') || '[]'); } catch (e) { cart = []; }
    if (!cart.length) return;
    getCatalog().then(function (prods) {
      var parts = [];
      cart.forEach(function (it) {
        var p = prods.find(function (pp) { return canon(pp.title) === canon(it.name); });
        if (!p) return;
        var v = matchVariant(p, it.variant);
        if (v) parts.push(v.id + ':' + Math.max(1, it.qty || 1));
      });
      if (!parts.length) { alert('Checkout is temporarily unavailable — please message us on WhatsApp and we will take your order there.'); return; }
      var url = '/cart/' + parts.join(',');
      try {
        var fc = (localStorage.getItem('fluxCoupon') || '').trim().toUpperCase(); if (/^(WELCOME10|FLUX5[A-Z0-9]{6})$/.test(fc) && !localStorage.getItem('fluxCouponUsed')) url += '?discount=' + fc;
      } catch (e) {}
      var disc = url.indexOf('?') > -1 ? url.slice(url.indexOf('?')) : '';
      var items = parts.map(function (s) { var a = s.split(':'); return { id: +a[0], quantity: +a[1] }; });
      var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      fetch('/cart/clear.js', { method: 'POST', headers: H })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw new Error('cart add ' + r.status); window.location.href = '/checkout' + disc; })
        .catch(function () { window.location.href = url; });
    }).catch(function (e) { console.warn('shopify checkout bridge', e); });
  }
  function install() { window.openCheckout = shopifyCheckout; }
  install();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { install(); setTimeout(install, 400); });
  } else { setTimeout(install, 400); }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#btnCheckout') : null;
    if (b) { e.preventDefault(); e.stopPropagation(); shopifyCheckout(); }
  }, true);
})();
;(function fluxSpeed(){try{if(!window.fbq){var n=window.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!window._fbq)window._fbq=n;n.push=n;n.loaded=true;n.version='2.0';n.queue=[];}window.fbq('set','autoConfig',false,'1002215386171573');var st=document.createElement('style');st.id='fluxSpeedCss';st.textContent='body *:not(#cartOverlay):not(#checkoutModal):not(#mobileMenu):not(.fcv-pop-bg){-webkit-backdrop-filter:none!important;backdrop-filter:none!important}#navbar{background-color:rgba(255,255,255,.97)}';(document.head||document.documentElement).appendChild(st);}catch(e){}})();
;(function(){try{var c=document.currentScript;if(!c||!c.src)return;var s=document.createElement('script');s.src=c.src.replace(/config\.js(\?[^#]*)?$/,'flux-cryova.js?v=20261008d');s.defer=true;document.head.appendChild(s);}catch(e){}})();
